export default __webpack_public_path__ + "static/media/50.97966b9c.svg";